import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Legacy route — workflow edit now lives on the automation detail screen.
 */
export default function AddOrEditWorkflowPage() {
  const { automationId, workflowId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!automationId) {
      navigate("/tracker-automations", { replace: true });
      return;
    }
    const key = !workflowId || workflowId === "new" ? "new" : workflowId;
    navigate(`/tracker-automations/${automationId}?workflow=${encodeURIComponent(key)}`, {
      replace: true,
    });
  }, [automationId, workflowId, navigate]);

  return null;
}
